import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

/**
 * Per-user preferences that are NOT scoped to a report / menu item
 * (public.user_preferences_app). Sibling of UserPreferenceReportModelSchema.
 *
 * Strict at the row level, open inside `data`: preference values live under
 * their own keys in the blob (first consumer: `current_area`), so adding a
 * second global preference later needs no model change on either side.
 */
export const UserPreferenceAppModelSchema = z
  .object({
    user_id: z.string(),
    data: z.record(z.string(), z.unknown())
  })
  .strict()

const UserPreferenceAppModelFields = makeFieldKeys(UserPreferenceAppModelSchema)

export type UserPreferenceAppModel = z.infer<typeof UserPreferenceAppModelSchema>
